import { UUID } from 'crypto'
import { AdministratorDto } from '../../pages/users/api/dto/get/AdministratorDto'

class Administrator {
  private constructor(id: UUID, userId: UUID) {
    this.id = id
    this.userId = userId
  }

  private readonly id: UUID
  private readonly userId: UUID

  static fromDto(
    userId: UUID,
    administratorDto: AdministratorDto,
  ): Administrator {
    const { id } = administratorDto
    return new Administrator(id, userId)
  }
}

export default Administrator
